<!-- src/views/OffersPage.vue -->

<template>
    <div>
      <OfferDetails :offer-id="offerId" />
    </div>
</template>

<script>
import OfferDetails from '@/components/OfferDetails.vue';

export default {
  name: 'OfferDetailsPage',
  components: {
    OfferDetails
  },
  computed: {
    offerId() {
      return this.$route.params.id;
    }
  }
}
</script>
